<!-- <div class="urgent-banner">
  <span class="material-icons warning-icon">warning</span>
  <span class="warning-text">{{ config?.warning_text || ('Stories.urgentNeedFunds' | translatePipe | async)}}</span>
  <span class="d-md-block days-left" [ngClass]="{'d-md-none': !config?.show_end_date, 'd-none': !config?.show_end_date}" *ngIf="(endDate | dayjs:'diffInDays') >= 0 && language !== 'en'">
    {{+(endDate | dayjs:'diffInDays') + 1}} {{'Stories.daysLeft' | translatePipe | async}}
  </span>
  <span class="d-md-block days-left" [ngClass]="{'d-md-none': !config?.show_end_date, 'd-none': !config?.show_end_date}" *ngIf="(endDate | dayjs:'diffInDays') >= 0 && language === 'en'">
    {{+(endDate | dayjs:'diffInDays') + 1}} {{+(endDate | dayjs:'diffInDays') + 1 ? 'day left' : 'Stories.daysLeft' | translatePipe | async}}
  </span>
</div> -->

<div class="urgent-banner">
  <div class="title">
    <span class="material-icons warning-icon">warning</span>
    <span class="warning-text">{{ config?.warning_text || ('Stories.urgentNeedFunds1' | translatePipe | async)}}</span>
  </div>
  <span class="d-md-block days-left" *ngIf="(endDate | dayjs:'diffInDays') >= 0 && language !== 'en'">
    {{+(endDate | dayjs:'diffInDays') + 1}} {{'Stories.daysLeft' | translatePipe | async}}
  </span>
  <span class="d-md-block days-left"  *ngIf="(endDate | dayjs:'diffInDays') >= 0 && language === 'en'">
    {{+(endDate | dayjs:'diffInDays') + 1}} {{+(endDate | dayjs:'diffInDays') === 0 ? 'day left' : 'Stories.daysLeft' | translatePipe | async}}
  </span>
</div>